const path = "./static/themes/default-theme/audio/";
export const defaultConfig = {
  triple: path + "triple.mp3",
  double: path + "double.mp3",
};
